import compact from 'lodash/compact';
import uniq from 'lodash/uniq';
import { useQuery } from '@tanstack/react-query';

import { userQueryOptions } from '@user/queries/userQueries';
import { userPracticeQueryOptions } from '@user/queries/userPracticeQueries';
import { medicalCaseQueryOptions } from '@store/MedicalCase/queries/medicalCaseQueries';
import { store } from '@store';

import { computeTaskPermissions, type TaskPermissions } from '../utils/taskPermissions';
import type { TaskFormState } from '../types';

export function useTaskPermissions(state: TaskFormState): TaskPermissions {
    const userIds = uniq(
        compact([state.authUserId, state.authorId, state.requesterId, ...state.executorIds, state.actualExecutorId]),
    );
    const { data: users = [] } = useQuery({
        ...userQueryOptions.list({ ids: userIds }),
        enabled: userIds.length > 0,
    });
    const { data: medicalCases = [] } = useQuery(medicalCaseQueryOptions.byIds(state.medicalCaseIds));
    const { data: authUserPractices = [] } = useQuery(userPracticeQueryOptions.byUserId(store.authUser.id));

    return computeTaskPermissions(state, {
        getUser: id => (id ? users.find(user => user.id === id) : undefined),
        medicalCases,
        authUserPracticeIds: authUserPractices.map(({ id }) => id),
    });
}
